import React, { useEffect, useState } from 'react';
import PaymentTable from './PaymentTable';
import Pagination from '../Pagination/Pagination';
import { useIsPageDesktop } from '../../App';
import { AllPaymentTable, IndividualPaymentTable, MultiPartyPaymentTable, MultipleClaimantsPaymentTable, ClaimantVendorPaymentTable, VendorPaymentTable } from '../../config/PaymentTableTypes';
import Export from '../Export/Export';
import { Alert } from '../Alert/Alert';
import Has from '../Permission/Has';
import { FF_PAY_SRCH_EXPORT } from '../../config/FeatureFlagTypes';
import { G_EXPORT_TRANSACTION } from '../../config/PermissionTypes';

export default function PaymentTableWrapper(props) {
    const [selectedPage, setSelectedPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [showExportBanner, setShowExportBanner] = useState(false);
    const [showCancelBanner, setShowCancelBanner] = useState(false);
    const [showExportErrorBanner, setShowExportErrorBanner] = useState(false);
    const [showQueryLimitBanner, setShowQueryLimitBanner] = useState(false);

    const isDesktop = useIsPageDesktop();
    const paymentData = props.paymentData;
    const paymentTableType = props.paymentTableType;

    function handleColumnSelect(column, direction) {
        if (props.updatePaymentData) {
            props.updatePaymentData({ column, direction });
        }
    }

    function handleDataExport(type) {
        if (type === "error") {
            setShowExportErrorBanner(true);
        } else {
            setShowExportBanner(true);
        }
    }

    function handleExportErrorClose() {
        setShowExportErrorBanner(false);
    }

    function handleExportPendingClose() {
        setShowExportBanner(false);
    }

    function buildExportBody() {
        const paymentHeaders = [];
        switch (paymentTableType) {
            case 'all':
                AllPaymentTable.forEach(item => {
                    paymentHeaders.push(item.display);
                })
                break;
            case 'individual':
                IndividualPaymentTable.forEach(item => {
                    paymentHeaders.push(item.display);
                })
                break;
            case 'multiParty':
                MultiPartyPaymentTable.forEach(item => {
                    paymentHeaders.push(item.display);
                })
                break;
            case 'multipleClaimants':
                MultipleClaimantsPaymentTable.forEach(item => {
                    paymentHeaders.push(item.display);
                })
                break;
            case 'claimantVendor':
                ClaimantVendorPaymentTable.forEach(item => {
                    paymentHeaders.push(item.display);
                })
                break;
            case 'vendor':
                VendorPaymentTable.forEach(item => {
                    paymentHeaders.push(item.display);
                })
                break;
            default:
                AllPaymentTable.forEach(item => {
                    paymentHeaders.push(item.display);
                })
                break;
        }

        return {
            paymentFilters: props.exportOptions, paymentHeaders: paymentHeaders
        }
    }

    function handleCancelCall() {
        setShowCancelBanner(true);
        props.cancel();
    }

    function handleCancelBannerClose() {
        setShowCancelBanner(false);
    }

    useEffect(() => {
    	handleQueryLimitBanner();
      }, [props.paymentData]);     // eslint-disable-line react-hooks/exhaustive-deps
    
    function handleQueryLimitBanner() {
    	if (paymentData.resultCount > paymentData.maxResults){
        	setShowQueryLimitBanner(true);
    	} else {
        	setShowQueryLimitBanner(false);
    	}
    }

    function handleQueryLimitBannerClose() {
        setShowQueryLimitBanner(false);
    }
    
    return (
        <React.Fragment>
            {showExportBanner ?
                <Alert type="info" handleOnClose={handleExportPendingClose} dataTestId="export-info">
                    <div data-testid="efup-export-pending-banner-text">Your data is currently being exported. Please do not navigate away from the page until your export is complete.</div>
                </Alert> : <React.Fragment />}
            {showExportErrorBanner ?
                <Alert type="error" handleOnClose={handleExportErrorClose} dataTestId="export-error">
                    <div data-testid="efup-export-error-banner-text">Something went wrong and we were unable to export the data at this time. Please try again later.</div>
                </Alert> : <React.Fragment />}
            {showCancelBanner ?
                <Alert type="success" handleOnClose={handleCancelBannerClose} dataTestId="cancel-success">
                    <div data-testid="efup-cancel-call-banner-text">Your search was successfully canceled.</div>
                </Alert> : <React.Fragment />}
            {showQueryLimitBanner ?
                <Alert type="info" handleOnClose={handleQueryLimitBannerClose} dataTestId="query-limit-info">
                    <div data-testid="efup-query-limit-banner-text">Search results are limited to {paymentData.maxResults} records.</div>
                </Alert> : <React.Fragment />}

            <div className="table-container">
                <Has featureFlag={FF_PAY_SRCH_EXPORT} permission={G_EXPORT_TRANSACTION}>
                    <Export handleExport={handleDataExport} exportOptions={buildExportBody()} />
                </Has>
                {isDesktop ? <Pagination
                    numberOfItems={paymentData.disbursements.length}
                    selectedPage={selectedPage}
                    setSelectedPage={setSelectedPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    type={`${paymentTableType}-payments-top`}
                /> : <React.Fragment />}
                <div className="cb-row">
                    <div className="cb-col-lg-12">
                        <PaymentTable
                            paymentData={paymentData.disbursements}
                            tableFilters={paymentData.tableFilters ? paymentData.tableFilters : undefined}
                            handleColumnSelect={handleColumnSelect}
                            pageSize={pageSize}
                            selectedPage={selectedPage}
                            type={paymentTableType}
                            isLoading={props.isLoading}
                            cancel={handleCancelCall}
                        />
                    </div>
                </div>
                {!props.isLoading && paymentData.disbursements.length === 0 &&
                    <div className='cb-row'>
                        <div className="cb-col-lg-12">
                            <div className='cb-notification cb-notification-notify'>
                                <i className='cb-icon icon-warning'></i>
                                Sorry, we could not find any payments for the selected filters. Please try again.
                            </div>
                        </div>
                    </div>
                }
                {isDesktop ? <Pagination
                    numberOfItems={paymentData.disbursements.length}
                    selectedPage={selectedPage}
                    setSelectedPage={setSelectedPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    type={`${paymentTableType}-payments-bottom`}
                /> : <React.Fragment />}
            </div>
        </React.Fragment>);
}